import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Fade } from 'react-reveal'

const SitemapContent = () => {
    const sectionIds = {
        home: 'sitemap-home',
        companyInfo: 'sitemap-company',
        individualProducts: 'sitemap-individual',
        corporateProducts: 'sitemap-corporate',
        financialProducts: 'sitemap-financial',
        services: 'sitemap-services',
        newsAndAnnouncements: 'sitemap-news',
        formsAndDownloads: 'sitemap-forms',
        financialReports: 'sitemap-reports',
        support: 'sitemap-support'
    }
    const navSections = [
        { label: 'Home', id: sectionIds.home },
        { label: 'Company Information', id: sectionIds.companyInfo },
        { label: 'Individual Products', id: sectionIds.individualProducts },
        { label: 'Corporate Products', id: sectionIds.corporateProducts },
        { label: 'Financial Products', id: sectionIds.financialProducts },
        { label: 'Services & Tools', id: sectionIds.services },
        { label: 'News & Announcements', id: sectionIds.newsAndAnnouncements },
        { label: 'Forms & Downloads', id: sectionIds.formsAndDownloads },
        { label: 'Financial Reports', id: sectionIds.financialReports },
        { label: 'Support & Information', id: sectionIds.support }
    ]
    const sitemapData = {
        home: [
            { name: 'Home', path: '/' }
        ],
        companyInfo: [
            { name: 'About Us', path: '/about-us' },
            { name: 'Who We Are', path: '/whoweare' },
            { name: 'Company Details', path: '/company-details' },
            { name: 'Governance', path: '/governance' },
            { name: 'Management', path: '/management' },
            { name: 'Shariah Advisor', path: '/shariah' },
            { name: 'ESG & Sustainability', path: '/esg' },
            { name: 'Life at Salaam', path: '/life-at-salaam' }
        ],
        individualProducts: [
            { name: 'Individual Products', path: '/Individual-Product' },
            // { name: 'Salam Motor', path: '/individualproduct/salammotor' },
            { name: 'Salam Home', path: '/individualproduct/salamhome' },
            { name: 'Salam Personal', path: '/individualproduct/salampersonal' },
            // { name: 'Salam Pet', path: '/individualproduct/salampet' },
            { name: 'Salam Sehat', path: '/individualproduct/salamsehat' },
            { name: 'Salam Medical', path: '/individualproduct/salammedical' },
            { name: 'Salam Travel', path: '/individualproduct/salamtravel' }
        ],
        corporateProducts: [
            { name: 'Corporate Products', path: '/Corporate-Product' },
            { name: 'Salam Livestock', path: '/corporateproduct/salamlivestock' },
            // { name: 'Salam Crop', path: '/corporateproduct/salamcrop' },
            { name: 'Salam Miscellaneous', path: '/corporateproduct/salam-miscellaneous' },
            { name: 'Salam Engineering', path: '/corporateproduct/salam-engineering' },
            // { name: 'Salaam Group Health', path: '/corporateproduct/salaam-group-health' },
            { name: 'Salam Fire', path: '/corporateproduct/salam-fire' },
            { name: 'Salam Marine', path: '/corporateproduct/salam-marine' }
        ],
        financialProducts: [
            { name: 'Financial Products', path: '/Financial-Product' },
            { name: 'Salaam Banker', path: '/financialproduct/salaam-banker' },
            { name: 'Salaam Professional', path: '/financialproduct/salaam-professional' },
            { name: 'Salaam Computer', path: '/financialproduct/salaam-computer' },
            { name: 'Salaam Plastic Card', path: '/financialproduct/salaam-plasticcard' },
            { name: 'Salaam Deposit', path: '/financialproduct/salaam-deposit' },
            { name: 'Salaam Cyber', path: '/financialproduct/salaam-cyber' }
        ],
        services: [
            { name: 'Buy Now', path: '/buynow' },
            { name: 'E-Verify', path: '/e-verify' },
            { name: 'Claim Intimation', path: '/claim' },
            { name: 'FIO', path: '/fio' }
        ],
        newsAndAnnouncements: [
            { name: 'News & Announcements', path: '/news-and-announcements' },
            { name: 'Articles & Blogs', path: '/articles-and-blogs' },
            { name: 'Annual Performance', path: '/annual-performance' },
            { name: 'Awards & Recognition', path: '/awards-&-recognition' }
        ],
        formsAndDownloads: [
            { name: 'Proposal Form', path: '/proposal-form' },
            { name: 'Claim Form', path: '/claim-form' },
            { name: 'Complaint Resolution Form', path: '/complaint-resolution-form' },
            { name: 'Un-Encashed Form', path: '/un-encahsed-form' },
            { name: 'Policies Form', path: '/policies-form' },
            { name: 'Proxy Forms', path: '/proxy-forms' },
            { name: 'Hospital Form', path: '/hospital-form' },
            { name: 'Discount Form', path: '/discount-form' },
            { name: 'Marketing Collateral Forms', path: '/marketing-collateral-forms' }
        ],
        financialReports: [
            { name: 'Financial Reports', path: '/financial-reports' },
            { name: 'Financial Highlights', path: '/financial-highlights' },
            { name: 'NOGM', path: '/nogm' }
        ],
        support: [
            { name: 'Complain Box', path: '/compain-box' },
            { name: 'Whistle Blowing', path: '/whistle-blowing' },
            { name: 'FAQ', path: '/faq' },
            { name: 'Contact Us', path: '/contactus' },
            { name: 'Privacy Policy', path: '/privacy-policy' }
        ]
    }

    const renderSection = (title, items, icon = '', sectionKey = '') => {
        const id = sectionKey ? sectionIds[sectionKey] : ''
        return (
            <Fade bottom>
                <div className="sitemap-section" id={id}>
                    <h3 className="sitemap-section-title">
                        {icon && <span className="sitemap-icon">{icon}</span>}
                        {title}
                    </h3>
                    <ul className="sitemap-list">
                        {items.map((item, index) => (
                            <li key={index} className="sitemap-item">
                                <Link 
                                    to={item.path} 
                                    className="sitemap-link"
                                    onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
                                >
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </Fade>
        )
    }

    const scrollToSection = (id) => {
        const el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    return (
        <Fragment>
            <div className="container sitemap-container">
                {/* In-page navigation lines */}
                <nav className="sitemap-nav-lines" aria-label="Sitemap sections">
                    <div className="sitemap-nav-lines-inner">
                        <span className="sitemap-nav-label">Jump to:</span>
                        <ul className="sitemap-nav-list">
                            {navSections.map((sec, i) => (
                                <li key={i} className="sitemap-nav-item">
                                    {i > 0 && <span className="sitemap-nav-sep">|</span>}
                                    <button
                                        type="button"
                                        className="sitemap-nav-link"
                                        onClick={() => scrollToSection(sec.id)}
                                    >
                                        {sec.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </nav>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="sitemap-wrapper">
                            {renderSection('Home', sitemapData.home, '🏠', 'home')}
                            {renderSection('Company Information', sitemapData.companyInfo, '🏢', 'companyInfo')}
                            {renderSection('Individual Products', sitemapData.individualProducts, '👤', 'individualProducts')}
                            {renderSection('Corporate Products', sitemapData.corporateProducts, '🏭', 'corporateProducts')}
                            {renderSection('Financial Products', sitemapData.financialProducts, '💼', 'financialProducts')}
                            {renderSection('Services & Tools', sitemapData.services, '🔧', 'services')}
                            {renderSection('News & Announcements', sitemapData.newsAndAnnouncements, '📰', 'newsAndAnnouncements')}
                            {renderSection('Forms & Downloads', sitemapData.formsAndDownloads, '📄', 'formsAndDownloads')}
                            {renderSection('Financial Reports', sitemapData.financialReports, '📊', 'financialReports')}
                            {renderSection('Support & Information', sitemapData.support, '💬', 'support')}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default SitemapContent
